module.exports = __webpack_public_path__ + "img/vip.ebf7c620.svg";